(function () {
  function qs(sel, root = document) { return root.querySelector(sel); }
  function qsa(sel, root = document) { return Array.from(root.querySelectorAll(sel)); }

  function openModal(modal) {
    modal.setAttribute('aria-hidden', 'false');
    document.documentElement.classList.add('camov-modal-open');
  }

  function closeModal(modal) {
    modal.setAttribute('aria-hidden', 'true');
    document.documentElement.classList.remove('camov-modal-open');
  }

  function clampSize(size, sizeMin, sizeMax) {
    const order = ['XS','S','M','L','XL','XXL'];
    const i = order.indexOf(size);
    const minI = order.indexOf((sizeMin || '').toUpperCase());
    const maxI = order.indexOf((sizeMax || '').toUpperCase());
    if (i === -1) return size;
    let out = i;
    if (minI !== -1) out = Math.max(out, minI);
    if (maxI !== -1) out = Math.min(out, maxI);
    return order[out] || size;
  }

async function applySizeToPage(size) {
  const target = (size || '').trim().toUpperCase();
  if (!target) return false;

  // Helper: pausa corta para que el theme procese cambios
  const wait = (ms) => new Promise(r => setTimeout(r, ms));

  // 1) Ubicar el bloque "Talla"
  const optionBlocks = Array.from(document.querySelectorAll('.option-selector'));
  const tallaBlock = optionBlocks.find(b => {
    const byAttr = (b.getAttribute('data-option') || '').trim().toLowerCase();
    const byLabel = (b.querySelector('label')?.textContent || '').trim().toLowerCase();
    return byAttr === 'talla' || byLabel === 'talla';
  });

  // 2) Intentar setear input/select REAL (compatible con Shopify)
//    IMPORTANTE: si son radios (píldoras), hay que marcar el radio correcto, no setear value.
if (tallaBlock) {
  // 2A) Caso radios: seleccionar el radio cuyo value sea target
  const radio = tallaBlock.querySelector(`input[type="radio"][value="${CSS.escape(target)}"]`);
  if (radio) {
    // Preferimos click porque muchos temas escuchan click sobre el label/radio
    radio.click();
    radio.checked = true;
    radio.dispatchEvent(new Event('change', { bubbles: true }));
    radio.dispatchEvent(new Event('input', { bubbles: true }));
    await wait(200);
    return true;
  }

  // 2B) Caso select
  const select =
    tallaBlock.querySelector('select[name^="options["]') ||
    tallaBlock.querySelector('select');

  if (select) {
    const opt = Array.from(select.options).find(o =>
      ((o.value || '').trim().toUpperCase() === target) ||
      ((o.textContent || '').trim().toUpperCase() === target)
    );

    if (opt) {
      select.value = opt.value;
      select.dispatchEvent(new Event('change', { bubbles: true }));
      select.dispatchEvent(new Event('input', { bubbles: true }));
      await wait(200);
      return true;
    }
  }

  // 2C) Caso botones tipo píldora sin radio accesible: clic por texto/atributo dentro del bloque talla
  const candidates = tallaBlock.querySelectorAll(
    'button, label, [role="radio"], [data-option-value], [data-value]'
  );

  const match = Array.from(candidates).find(el => {
    const text = (el.textContent || '').trim().toUpperCase();
    const data =
      (el.getAttribute('data-option-value') || el.getAttribute('data-value') || '').trim().toUpperCase();
    return text === target || data === target;
  });

  if (match) {
    match.click();
    await wait(200);
    return true;
  }
}


  // 3) Soporte específico para tu <custom-select> (si no hay field real accesible)
  if (tallaBlock) {
    const cs = tallaBlock.querySelector('custom-select');
    const btn = cs?.querySelector('.custom-select__btn');
    const opt = cs?.querySelector(`.custom-select__option[data-value="${target}"]`);

    if (cs && btn && opt) {
      // Secuencia de eventos "reales" (click solo no sirve en tu caso)
      const fireMouse = (el, type) =>
        el.dispatchEvent(new MouseEvent(type, { bubbles: true, cancelable: true, view: window }));

      const firePointer = (el, type) => {
        try {
          el.dispatchEvent(new PointerEvent(type, { bubbles: true, cancelable: true, view: window }));
        } catch (e) {
          // si el browser no soporta PointerEvent en este contexto, ignoramos
        }
      };

      // Abrir
      firePointer(btn, 'pointerdown');
      fireMouse(btn, 'mousedown');
      fireMouse(btn, 'mouseup');
      fireMouse(btn, 'click');
      await wait(150);

      // Seleccionar opción
      firePointer(opt, 'pointerdown');
      fireMouse(opt, 'mousedown');
      fireMouse(opt, 'mouseup');
      fireMouse(opt, 'click');
      await wait(200);

      // Verificar si quedó seleccionada
      const selected = cs.querySelector('.custom-select__option[aria-selected="true"]')?.getAttribute('data-value');
      if ((selected || '').toUpperCase() === target) return true;

      // Fallback: forzar aria-selected (último recurso visual)
      cs.querySelectorAll('.custom-select__option').forEach(o => o.setAttribute('aria-selected', 'false'));
      opt.setAttribute('aria-selected', 'true');
      return true;
    }
  }

  // 4) Fallback general (por si tu theme cambia)
  const generic = document.querySelector(`[data-option-value="${target}"], [data-value="${target}"], [data-option="${target}"]`);
  if (generic) {
    generic.click();
    await wait(150);
    return true;
  }

  return false;
}


  function safeJsonParse(str, fallback) {
    try {
      const s = (str || '').trim();
      if (!s) return fallback;
      return JSON.parse(s);
    } catch (e) {
      return fallback;
    }
  }

  // fit_rules puede venir como objeto o array; esto lo normaliza
  function getProductOffsetFromRules(rules) {
    // array: [{fit_offset: 1, ...}]
    if (Array.isArray(rules)) {
      return Number(rules?.[0]?.fit_offset ?? 0) || 0;
    }
    // objeto: {fit_offset: 1, ...}
    if (rules && typeof rules === 'object') {
      return Number(rules?.fit_offset ?? 0) || 0;
    }
    return 0;
  }

  function initOne(blockRoot) {
    const modal = qs('.camov-size-modal', blockRoot);
    if (!modal) return;

    const fitMapEl = qs('[data-fit-map]', blockRoot);
    const rulesEl  = qs('[data-fit-rules]', blockRoot);

    const resultText = qs('[data-camov-result]', blockRoot);
    const resultSize = qs('.camov-size-result__size', blockRoot);
    const applyBtn   = qs('[data-camov-apply]', blockRoot);

    const sizeMinEl = qs('[data-size-min]', blockRoot);
    const sizeMaxEl = qs('[data-size-max]', blockRoot);

    const sizeMin = sizeMinEl ? (sizeMinEl.textContent || '').trim().toUpperCase() : '';
    const sizeMax = sizeMaxEl ? (sizeMaxEl.textContent || '').trim().toUpperCase() : '';

    // Parse JSON de forma robusta
    const fitMap = safeJsonParse(fitMapEl ? fitMapEl.textContent : '', null);
    const rules  = safeJsonParse(rulesEl  ? rulesEl.textContent  : '', null);

    // Offset del producto (polera ajustada +1, polerón suelto -1, etc.)
    const productOffset = getProductOffsetFromRules(rules);

    let selectedFit = null;     // ajustado|normal|suelto|oversize
    let selectedSize = null;    // XS|S|M|L|XL|XXL
    let computed = null;        // talla recomendada

    function compute() {
      computed = null;

      if (!fitMap || !rules) {
        if (resultText) resultText.textContent = 'Falta configuración (fit map / rules).';
        if (resultSize) resultSize.textContent = '';
        if (applyBtn) applyBtn.setAttribute('disabled', 'disabled');
        return;
      }

      if (!selectedFit || !selectedSize) {
        if (resultText) resultText.textContent = 'Selecciona calce y talla.';
        if (resultSize) resultSize.textContent = '';
        if (applyBtn) applyBtn.setAttribute('disabled', 'disabled');
        return;
      }

      // Offset por preferencia del usuario
      const userOffset = Number(fitMap[selectedFit] ?? 0);
      if (Number.isNaN(userOffset)) {
        if (resultText) resultText.textContent = 'Configuración inválida (offset).';
        if (resultSize) resultSize.textContent = '';
        if (applyBtn) applyBtn.setAttribute('disabled', 'disabled');
        return;
      }

      const order = ['XS','S','M','L','XL','XXL'];
      const baseI = order.indexOf(selectedSize);
      if (baseI === -1) return;

      // ✅ APLICAR userOffset + productOffset
      const finalIndex = Math.max(
        0,
        Math.min(order.length - 1, baseI + userOffset + productOffset)
      );

      const raw = order[finalIndex];
      computed = clampSize(raw, sizeMin, sizeMax);

      if (resultText) resultText.textContent = 'Tu talla recomendada:';
      if (resultSize) resultSize.textContent = computed;
      if (applyBtn) applyBtn.removeAttribute('disabled');
    }

    // open
    qsa('[data-camov-open]', blockRoot).forEach(btn => {
      btn.addEventListener('click', () => openModal(modal));
    });

    // close
    qsa('[data-camov-close]', modal).forEach(btn => {
      btn.addEventListener('click', () => closeModal(modal));
    });

    document.addEventListener('keydown', (e) => {
      if (e.key !== 'Escape') return;
      const open = qs('.camov-size-modal[aria-hidden="false"]');
      if (open) closeModal(open);
    });

    // selection UI
    qsa('[data-camov-fit-group] .camov-opt', modal).forEach(btn => {
      btn.addEventListener('click', () => {
        qsa('[data-camov-fit-group] .camov-opt', modal).forEach(b => b.classList.remove('is-active'));
        btn.classList.add('is-active');
        selectedFit = (btn.getAttribute('data-fit') || '').trim();
        compute();
      });
    });

    qsa('[data-camov-size-group] .camov-opt', modal).forEach(btn => {
      btn.addEventListener('click', () => {
        qsa('[data-camov-size-group] .camov-opt', modal).forEach(b => b.classList.remove('is-active'));
        btn.classList.add('is-active');
        selectedSize = (btn.getAttribute('data-size') || '').trim().toUpperCase();
        compute();
      });
    });

    // apply
    if (applyBtn) {
      applyBtn.addEventListener('click', async () => {
  if (!computed) return;

  await applySizeToPage(computed);
  closeModal(modal);
});

    }

    // initial state
    if (resultText) resultText.textContent = 'Selecciona calce y talla.';
    if (applyBtn) applyBtn.setAttribute('disabled', 'disabled');
  }

  function init() {
    qsa('[data-camov-size-finder]').forEach(initOne);
  }

  document.addEventListener('DOMContentLoaded', init);
})();
